import useGet from "../../../hooks/useGet"
import Table from "../../../components/table"
import columns from "./column";
import useTable from "../../../hooks/useTable"
import CardContainer from "../../../components/card_container"
import { EDITUSER, DETAILUSER } from "../../../routes/routes_name";
import CustomModal from "../../../components/custom_modal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const UserPage = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const navigate = useNavigate();
    const {
        filter,
        isLoading,
        data,
        error,
        totalPages,
        handlePagination,
        handleLimit,
        handleFilter,
    } = useGet('/v1/user')

    const {
        isLoading: isLoadingPost,
        dataRemove,
        handleEdit,
        handleSelected,
        handleRemove
    } = useTable();

    const handleDetail = () => {
        if (dataRemove.length !== 1) {
            return;
        }

        const selected = dataRemove[0];
        const selectedId = selected?.id || selected?._id;

        if (selectedId) {
            navigate(DETAILUSER.replace(":id", selectedId));
        }
    }


    return (
        <>
            <CardContainer
                title="List of User"
                isHeader={true}
                editShow={dataRemove.length === 1}
                editClick={() => handleEdit(EDITUSER)}
                onSearchChange={handleFilter}
                detailClick={handleDetail}
                detailShow={dataRemove.length === 1}
                searchPlaceholder="Search name or email">
                <div className="expanded-y">
                    <div className="table-content">
                        <Table
                            filter={filter}
                            isLoading={isLoading}
                            error={error}
                            data={data}
                            totalPages={totalPages}
                            handlePagination={handlePagination}
                            handleLimit={() => { }}
                            handleChangeSelect={handleSelected}
                            columns={columns} />
                    </div>
                </div>
            </CardContainer>
        </>
    )
}

export default UserPage;
